import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export interface DeleteCertificatesParams {
  companyId: string;
  certificateId: number;
}

/**
 * 등록된 인증서 삭제 API
 * @link https://bank.dev.clobe.ai/swagger-ui/index.html#/Certificate%20API/deleteCompanyCertificate
 *
 * @param {string} companyId - 기업 id
 * @param {string} certificateId - 인증서 id
 * @returns
 */
export default function deleteCertificates({ companyId, certificateId }: DeleteCertificatesParams) {
  return API.delete<ResponseBaseWithData>(
    `/api/v2/companies/${companyId}/certificates/${certificateId}`,
  );
}
